import type { Tag } from "../../convex/types";

// ---------------------------------------------------------------------------
// status tags close out a listing (sold or rented), so the staff ui shows
// them in red and hides every other tag on that listing
// ---------------------------------------------------------------------------

export const SOLD_TAG_NAME = "SOLD!";
export const RENTED_TAG_NAME = "Rented";

/**
 * Returns true when the tag name marks a listing as sold or rented.
 */
export function isStatusTagName(tagName: string): boolean {
  return tagName === SOLD_TAG_NAME || tagName === RENTED_TAG_NAME;
}

/**
 * Returns the SOLD! and Rented tags from a listing's tags.
 */
export function getStatusTags(propertyTags: Tag[]): Tag[] {
  return propertyTags.filter((tag) => isStatusTagName(tag.tag_name));
}

/**
 * Resolves a listing's tag ids to tag docs in the listing's order, skipping
 * ids with no matching tag (deleted, or tags still loading).
 */
export function resolvePropertyTags(
  tagIds: string[],
  tags: Tag[] | undefined,
): Tag[] {
  if (tags === undefined) {
    return [];
  }

  return tagIds.reduce((result: Tag[], tagId) => {
    const match = tags.find((tag) => tag._id === tagId);
    if (match !== undefined) {
      result.push(match);
    }
    return result;
  }, []);
}
